<!-- Unique wrapper based on instance ID -->
<div [id]="'primer-container-' + uniqueInstanceId" class="primer-headless">
  <!-- Card Number -->
  <div id="checkout-card-input-wrapper" class="creditcard-indicator input">
    <label class="required" for="checkout-card-number-input" i18n="@@payment_method.label.creditcard_number">
      Kreditkarten-Nummer
    </label>
    <div class="d-flex align-items-center">
      <div
        id="checkout-card-number-input"
        class="form-control ng-dirty"
        #cardNumberDiv
        [ngClass]="creditCardType$ | async"
        [class.ng-touched]="touchedByField$.cardNumber | async"
        [class.ng-invalid]="errorByField$.cardNumber | async"
        [class.ng-valid]="successByField$.cardNumber | async"
      ></div>
      <ng-container *ngIf="_showNetworkToggle$ | async">
        <mat-button-toggle-group
          class="ml-2 network-toggle"
          [value]="_selectedNetwork"
          (change)="selectNetwork($event.value)"
          [hideSingleSelectionIndicator]="true"
        >
          <mat-button-toggle
            *ngFor="let network of _detectedCardNetworks"
            [value]="network.network"
            [attr.aria-label]="'Select ' + network.network + ' network'"
            class="network-toggle-button"
          >
            <div class="network-icon" [ngClass]="getNetworkClass(network.network)"></div>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </ng-container>
    </div>
    <ng-container *ngIf="touchedByField$.cardNumber | async">
      <div class="error-container" *ngIf="errorByField$.cardNumber | async as error">
        {{ error }}
      </div>
    </ng-container>
  </div>

  <div class="d-flex">
    <!-- Expiry -->
    <div id="checkout-card-expiry-wrapper" class="input">
      <label class="required" for="checkout-card-expiry-input" i18n="@@payment_method.label.valid_to">
        Gültig bis
      </label>
      <div
        id="checkout-card-expiry-input"
        class="form-control ng-dirty"
        #cardExpiryDiv
        [class.ng-touched]="touchedByField$.expirationDate | async"
        [class.ng-invalid]="errorByField$.expirationDate | async"
        [class.ng-valid]="successByField$.expirationDate | async"
      ></div>
      <ng-container *ngIf="touchedByField$.expirationDate | async">
        <div class="error-container" *ngIf="errorByField$.expirationDate | async as error">
          {{ error }}
        </div>
      </ng-container>
    </div>

    <!-- CVV -->
    <div id="checkout-card-cvv-wrapper" class="input">
      <div id="checkout-card-cvv-label-wrapper">
        <label class="required" for="checkout-card-cvv-input" i18n="@@payment_method.label.cvv"> CVV </label>
        <a
          id="creditcard_securitycode_help"
          href="#"
          tabIndex="-1"
          (click)="onCvvHelpClick($event)"
          i18n="@@payment_method.label.cvv_whats_this"
        >
          Was ist CVV?
        </a>
      </div>
      <div
        id="checkout-card-cvv-input"
        class="form-control ng-dirty"
        #cardCvvDiv
        [class.ng-touched]="touchedByField$.cvv | async"
        [class.ng-invalid]="errorByField$.cvv | async"
        [class.ng-valid]="successByField$.cvv | async"
      ></div>
      <ng-container *ngIf="touchedByField$.cvv | async">
        <div class="error-container" *ngIf="errorByField$.cvv | async as error">
          {{ error }}
        </div>
      </ng-container>
    </div>
  </div>
</div>
<orderform-cvc-dialog #cvcDialog></orderform-cvc-dialog>
